import React from 'react'
import { Column } from 'primereact/column'
import ChannelBodyTemplate from './ChannelBodyTemplate'
import ChannelsAutoCompleteEditor from './ChannelsAutoCompleteEditor'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

const ChannelColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, dataKey, selectedChannels, setSelectedChannels, channels, originalData }) => {
    const filterAttributes = {
        filter,
        filterPlaceholder: `Search by  ${title}`,
        required: !!filter,
        disabled: !filter
    }
    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            body={(rowData) => (
                <span className={`${checkFieldChanged(rowData) ? 'changed-field' : ''} ${rowData.isDeleted ? 'pending-deletion' : ''}`}>
                    <ChannelBodyTemplate rowData={rowData} />
                </span>
            )}
            editor={editable ? (options) => (
                <ChannelsAutoCompleteEditor
                    field={options.field}
                    rowData={options.rowData}
                    rowIndex={options.rowIndex}
                    dataKey={dataKey}
                    selectedChannels={selectedChannels}
                    setSelectedChannels={setSelectedChannels}
                    channels={channels}
                    editorCallback={options.editorCallback}
                    validationErrors={validationErrors}
                />
            ) : null}
            {...filterAttributes}/>
    )
}

export default ChannelColumn
